<template>
  <div class="rest-setting">
    <Navbar title="休息时间设置"></Navbar>
    <!-- 标签栏 -->
    <div class="tabbar">
      <van-tabs
        type="card"
        color="#007aff"
        title-inactive-color="black"
        v-model="holidayForm.category"
      >
        <van-tab title="洗车清洁" name="1">
          <!-- 休息时间 -->
          <div class="block">
            <div class="title">休息时间设置</div>
            <div
              class="content"
              v-for="(item, index) in holidayList"
              :key="index"
            >
              <div class="rest-item" v-if="item.category == 1">
                <van-row class="date">
                  <van-col span="22">{{ item.holidayDate }}</van-col>
                  <van-col span="2">
                    <van-icon
                      name="clear"
                      @click="handleDeleteRest(index, item.id)"
                    />
                  </van-col>
                </van-row>
                <van-row class="time">
                  <van-col
                    span="12"
                    v-for="(project, index) in item.times"
                    :key="index"
                  >
                    <van-icon name="checked" />
                    <span>{{ project.startTime + "-" + project.endTime }}</span>
                  </van-col>
                  <van-col span="12" v-if="item.isAllDay === true">
                    <van-icon name="checked" />
                    <span>全天</span>
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="爱车保养" name="2">
          <!-- 休息时间 -->
          <div class="block">
            <div class="title">休息时间设置</div>
            <div
              class="content"
              v-for="(item, index) in holidayList"
              :key="index"
            >
              <div class="rest-item" v-if="item.category == 2">
                <van-row class="date">
                  <van-col span="22">{{ item.holidayDate }}</van-col>
                  <van-col span="2">
                    <van-icon
                      name="clear"
                      @click="handleDeleteRest(index, item.id)"
                    />
                  </van-col>
                </van-row>
                <van-row class="time">
                  <van-col
                    span="12"
                    v-for="(project, index) in item.times"
                    :key="index"
                  >
                    <van-icon name="checked" />
                    <span>{{ project.startTime + "-" + project.endTime }}</span>
                  </van-col>
                  <van-col span="12" v-if="item.isAllDay === true">
                    <van-icon name="checked" />
                    <span>全天</span>
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="车辆维修" name="3">
          <!-- 休息时间 -->
          <div class="block">
            <div class="title">休息时间设置</div>
            <div
              class="content"
              v-for="(item, index) in holidayList"
              :key="index"
            >
              <div class="rest-item" v-if="item.category == 3">
                <van-row class="date">
                  <van-col span="22">{{ item.holidayDate }}</van-col>
                  <van-col span="2">
                    <van-icon
                      name="clear"
                      @click="handleDeleteRest(index, item.id)"
                    />
                  </van-col>
                </van-row>
                <van-row class="time">
                  <van-col
                    span="12"
                    v-for="(project, index) in item.times"
                    :key="index"
                  >
                    <van-icon name="checked" />
                    <span>{{ project.startTime + "-" + project.endTime }}</span>
                  </van-col>
                  <van-col span="12" v-if="item.isAllDay === true">
                    <van-icon name="checked" />
                    <span>全天</span>
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <!-- 提交 -->
    <div class="btn">
      <van-button type="primary" @click="addRestPopup = true">
        新增休息
      </van-button>
      <van-button type="info" @click="handlePreview">预览</van-button>
    </div>
    <!-- 新增休息时间弹框 -->
    <van-popup v-model="addRestPopup" class="add-Rest-popup">
      <div class="title">新增休息时间</div>
      <div class="form">
        <van-form>
          <van-field
            readonly
            clickable
            name="calendar"
            :value="holidayForm.holidayDate"
            label="日期"
            placeholder="点击选择日期"
            @click="showCalendar = true"
          />
          <van-row class="time">
            <van-checkbox-group v-model="holidayForm.times">
              <div
                class="div"
                v-for="(item, index) in appointmentList"
                :key="index"
              >
                <van-col span="12" v-if="item.category == 1">
                  <van-checkbox :name="item.id">
                    {{ item.startTime + "-" + item.endTime }}
                  </van-checkbox>
                </van-col>
              </div>
            </van-checkbox-group>
            <van-col span="12">
              <van-checkbox v-model="holidayForm.allDay">全天</van-checkbox>
            </van-col>
          </van-row>
          <div style="margin-top: 16px;">
            <van-button round block type="info" @click="handleAddRest">
              确定
            </van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <!-- 日历 -->
    <van-calendar v-model="showCalendar" @confirm="handleDate" />
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import { Dialog } from "vant";
import {
  addRest,
  deleteRest,
  restList,
  appointmentTimeList
} from "@/api/appointment";
export default {
  components: {
    Navbar
  },
  data() {
    return {
      addRestPopup: false,
      showCalendar: false,
      restDate: "",
      appointmentList: [],
      holidayList: [],
      holidayForm: {
        allDay: false,
        category: "",
        holidayDate: "",
        times: []
      }
    };
  },
  mounted() {
    this.handleAppointmentTimeList();
    this.handleRestList();
  },
  methods: {
    // 获取预约时间段
    handleAppointmentTimeList() {
      appointmentTimeList().then(res => {
        // console.log("预约时间段 :>> ", res);
        this.appointmentList = res;
      });
    },
    // 休息日列表
    handleRestList() {
      restList().then(res => {
        // console.log("休息日列表 :>> ", res);
        this.holidayList = res;
      });
    },
    // 日期格式化
    formatDate(date) {
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let year = date.getFullYear();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      let invalidDate = year + "-" + month + "-" + day;
      return invalidDate;
    },
    // 日期选择
    handleDate(date) {
      this.holidayForm.holidayDate = this.formatDate(date);
      this.showCalendar = false;
    },
    // 新增休息时间
    handleAddRest() {
      console.log(this.holidayForm);
      if (!this.handleFormVerify()) {
        return false;
      }
      this.addRestPopup = false;
      addRest([this.holidayForm]).then(res => {
        // console.log("新增休息时间:", res);
        if (res.code === 0) {
          this.$toast("新增成功");
          this.handleRestList();
          this.handleCancel();
        }
      });
    },
    // 删除休息时间段
    handleDeleteRest(index, id) {
      Dialog.confirm({
        title: "温馨提示",
        message: "确定删除该休息时间段吗?"
      }).then(() => {
        this.holidayList.splice(index, 1);
        deleteRest(id).then(res => {
          // console.log("删除预约时间段 :>> ", res);
          if (res.code === 0) {
            this.$toast("删除成功");
            this.handleRestList();
          }
        });
      });
    },
    // 取消
    handleCancel() {
      this.holidayForm.holidayDate = "";
      this.holidayForm.times = [];
      this.holidayForm.allDay = false;
      this.addRestPopup = false;
    },
    // 表单校验
    handleFormVerify() {
      if (this.holidayForm.holidayDate.trim() === "") {
        this.$toast("请输入休息日期");
        return false;
      }
      if (
        this.holidayForm.times.length === 0 &&
        this.holidayForm.allDay === false
      ) {
        this.$toast("请勾选休息时间段");
        return false;
      }
      return true;
    },
    // 预览
    handlePreview() {
      let dealerId = JSON.parse(sessionStorage.getItem("userInfo")).dealerId;
      window.location.href = this.$activityBreak + dealerId;
    }
  }
};
</script>
<style lang="scss" scoped>
.rest-setting {
  .tabbar {
    padding: 0 16px;

    .block {
      padding: 0 16px;
      margin-bottom: 20px;

      .title {
        margin-bottom: 10px;
        text-align: left;
        font-size: 14px;
        color: #a1a1a1;
      }

      .content {
        padding: 0 16px;

        .add {
          height: 30px;
          margin: 16px 0;
          border-radius: 5px;
        }

        .rest-item {
          margin: 10px;

          .date {
            padding: 5px 0;
            border-bottom: 1px solid #ccc;
          }

          .time {
            padding: 5px 0;
          }
        }
      }
    }
  }

  .btn {
    display: flex;
    justify-content: space-around;
  }

  .add-Rest-popup {
    width: 90%;
    padding: 20px 30px;
    box-sizing: border-box;

    .title {
      margin-bottom: 20px;
    }
  }
}
</style>
<style lang="scss">
.rest-setting {
  .tabbar {
    .van-tabs {
      .van-tabs__wrap {
        margin-bottom: 20px;
      }

      .van-tab {
        margin-right: 10px;
        border-radius: 5px;
      }

      .van-tab:last-child {
        margin: 0;
      }

      .van-tabs__nav--card {
        margin: 0;
        border: none;
      }

      .van-tabs__nav--card .van-tab {
        border: 1px solid #0079fe;
      }

      .van-tabs__nav--card .van-tab.van-tab--active {
        background-color: #0079fe;
      }
    }

    .block {
      .content {
        .rest-item {
          .date {
            .van-col--22 {
              text-align: left;
            }

            .van-icon {
              color: red;
            }
          }

          .time {
            .van-col {
              display: flex;
              align-items: center;
            }

            .van-icon {
              margin-right: 5px;
            }
          }
        }
      }
    }
  }

  .add-Rest-popup {
    .van-button--block {
      width: 50%;
      margin: 0 auto;
    }

    .form {
      .van-cell::after {
        display: none;
      }

      .van-col {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
